const defaults = {
    selector: '.load-wrapper',
    loadingClass: 'loading-posts',
    globalName: 'wlLoader',
}

const toJQuery = (target, fallbackSelector) => {
    if (target && target.jquery) {
        return target;
    }
    if (target instanceof Element || target === document || target === window) {
        return $(target);
    }
    return $(target || fallbackSelector);
}

export class Loader {
    static MIN_VIST_MS = 650;

    constructor(options = {}) {
        this.selector = options.selector || defaults.selector;
        this.loadingClass = options.loadingClass || defaults.loadingClass;
    }

    getTarget(target = this.selector) {
        return toJQuery(target, this.selector);
    }

    show(target = this.selector) {
        const $target = this.getTarget(target);
        $target.addClass(this.loadingClass);
        /* Tidsstempl visningen, så hide() kan holde loaderen oppe et øjeblik
           endnu: et svar på 300 ms gav ellers et glimt, man ikke nåede at
           opfatte som en animation (Mads 17/8). */
        $target.each((_, el) => {
            el.dataset.loaderShownAt = String(Date.now());
        });
        return $target;
    }

    /* Minimumsvisning: er svaret hurtigere end MIN_VIST_MS, bliver loaderen
       stående resten af tiden. Ellers når man kun at se et glimt — og et
       glimt af en animation ligner en animation der ikke kører. */
    hide(target = this.selector) {
        const $target = this.getTarget(target);
        $target.each((_, el) => {
            const vistFra = Number(el.dataset.loaderShownAt) || 0;
            const gaaet = Date.now() - vistFra;
            if (!vistFra || gaaet >= Loader.MIN_VIST_MS) {
                el.classList.remove(this.loadingClass);
                delete el.dataset.loaderShownAt;
                return;
            }

            window.clearTimeout(Number(el.dataset.loaderHideTimer) || 0);
            el.dataset.loaderHideTimer = String(window.setTimeout(() => {
                el.classList.remove(this.loadingClass);
                delete el.dataset.loaderShownAt;
                delete el.dataset.loaderHideTimer;
            }, Loader.MIN_VIST_MS - gaaet));
        });
        return $target;
    }

    toggle(target = this.selector, force = null) {
        const $target = this.getTarget(target);
        if (typeof force === 'boolean') {
            $target.toggleClass(this.loadingClass, force);
        } else {
            $target.toggleClass(this.loadingClass);
        }
        return $target;
    }
}

export const loader = new Loader();

export const registerLoaderGlobal = (globalName = defaults.globalName) => {
    if (typeof window === 'undefined') {
        return loader;
    }
    window[globalName] = loader;
    window.showLoader = (target = defaults.selector) => loader.show(target);
    window.hideLoader = (target = defaults.selector) => loader.hide(target);
    window.toggleLoader = (target = defaults.selector, force = null) => loader.toggle(target, force);
    return loader;
}
